import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml: `A sine wave is propagating from left to right and/or from right to left. Velocity field and pressure field can be visualized with arrows and colors, respectively, or as a graph. The movable pair of microphones is recording the pressure and velocity as a function of time (graph below). You may play with the amplitude and the phase of each wave. Do not hesitate to pause the motion in order to freeze the situation and move the microphones to explore the time trace of pressure and velocity at any position. The frequency, the wavelength and the speed of sound can be changed as well. See how modifying two of these parameters affects the third one.\n<hr />\n <div style="display:flex;align-items:center;gap:10px">\n<i class="cil-comment-bubble-exclamation" style="font-size:21px"></i>\n<span style="font-size:10px;font-weight:700;line-height:16px">animation slowed down by 3000x, displacement multipled by 50000, medium: air, standing wave ratio: 7.32</span>\n</div>`,
  collapsibleDescription: true,
  collapsedDescriptionTextLines: 2,
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0104/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
